export default {
  name: 'UserPicker',
  props: ['value', 'disabled', 'clientApiId', 'roles'],
  data () {
    return {
      loading: false,
      content: this.value,
      itemOptions: null,
      searchTxt: '',
      currentReq: null
    };
  },
  computed: {
    hasAnyResults () {
      return this.itemOptions && this.searchTxt && this.searchTxt.length > 0 && this.itemOptions.length === 0;
    }
  },
  methods: {
    updateValue () {
      this.$emit('input', this.content);
      this.$emit('changed', this.content);
    },
    searchFocus () {
      if (this.content === null) {
        this.searchItem(this.searchTxt)
      }
    },
    searchItem () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.content = null;
      this.updateValue();
      const self = this;
      const search = this.searchTxt.trim();
      if (search.length > 2 || self.roles || this.clientApiId) {
        setTimeout(
          function () {
            if (search === self.searchTxt.trim()) {
              self.loading = true;
              let path = 'user/find?perPage=10&qry=' + search;
              if (self.clientApiId) {
                path += '&client=' + self.clientApiId;
              }
              if (self.roles) {
                path += '&roles=' + self.roles;
              }
              self.currentReq = self.ApiRequest.request(path, self.ApiRequest.REQUEST_GET, [], function (response) {
                if (response.data) {
                  self.itemOptions = response.data;
                  self.loading = false;
                }
              });
            }
          }, 500);
      } else {
        this.loading = false;
        self.itemOptions = null;
      }
    },
    getItemText (item) {
      if (item) {
        return item.name + ' (' + item.email + ')';
      }
      return '';
    },
    selectItem (item) {
      this.searchTxt = this.getItemText(item);
      this.content = item;
      this.updateValue();
      this.itemOptions = null;
      this.loading = false;
    },
    clearSearch () {
      this.itemOptions = null;
      this.searchTxt = '';
      this.content = null;
      this.loading = false;
      this.updateValue();
    },
    editElement (refName, element) {
      this.$refs[refName].show(element);
    }
  },
  mounted () {
    this.searchTxt = this.getItemText(this.content);
  },
  watch: {
    value () {
      this.searchTxt = this.getItemText(this.value);
    }
  }
}
